import moment from 'moment';

export const dateStandard = (date) => {
    return moment(date).format("DD-MM-YYYY");
}

export const dateObject = () => {
    return moment();
}

export const dateDev = (date) => {
    return moment(date).format("YYYY-MM-DD");
}

export const dateBasicFormant = (date) => {
    var _date = moment(date, "YYYY-MM-DD");
    return _date._d;
}


export const dayInFuture = (dayNum) => {
    const sundays = [];
    var sunday = new Date()
    sunday.setDate(sunday.getDate() + dayNum - sunday.getDay());
    for (var i = 0; i < 55; i++) {
        // console.log(sunday.toLocaleString());
        sundays.push(new Date(sunday.getTime()));
        sunday.setDate(sunday.getDate() + 7);
    }
    return sundays;

}

export const addDate = (date, day) => {
    return date ? moment(new Date(date)).add(day, 'days').format("DD-MM-YYYY") : "";
}
export const getTimeDifferenceInMinutes = (lastDateStr) => {
    // Parse the input date string into a Date object
    if (lastDateStr) {
        const [day, month, yearAndTime] = lastDateStr.split("-");
        const [year, time] = yearAndTime.split(" ");
        const [hour, minute, second] = time.split(":");

        const lastDate = new Date(
            parseInt(year),
            parseInt(month) - 1, // months are 0-based in JS
            parseInt(day),
            parseInt(hour),
            parseInt(minute),
            parseInt(second)
        );
        // Current time
        const currentTime = new Date();
        // Difference in minutes
        const diffMinutes = (currentTime - lastDate) / (1000 * 60);
        return diffMinutes;
    }
    else
        return 0;
}